enum RolesEnum {
    SALES_ROLE = 7,
    SALES_INSURANCE_ROLE = 8,
    MICRO_FINANCE_ROLE = 10,
    FREE_AGENT_ROLE = 11,
    MARKETER_ROLE = 12,
}

export default RolesEnum
